import { v2 as cloudinary } from 'cloudinary';

// Configure Cloudinary
cloudinary.config(process.env.CLOUDINARY_URL || {
  cloud_name: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
  api_key: process.env.REACT_APP_CLOUDINARY_API_KEY,
  api_secret: process.env.REACT_APP_CLOUDINARY_API_SECRET
});

// Upload file to Cloudinary
export const uploadFile = async (file, folder = 'zedscholar') => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
    formData.append('folder', folder);
    
    // Set resource_type based on file type
    if (file.type === 'application/pdf') {
      formData.append('resource_type', 'raw');
    }

    // Use appropriate endpoint based on resource type
    const endpoint = file.type === 'application/pdf' 
      ? `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/raw/upload`
      : `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/auto/upload`;

    const response = await fetch(endpoint, {
      method: 'POST',
      body: formData
    });

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error.message);
    }

    return {
      url: data.secure_url,
      publicId: data.public_id,
      format: data.format,
      size: data.bytes
    };
  } catch (error) {
    console.error('Cloudinary upload error:', error);
    throw error;
  }
};

// Delete file from Cloudinary
export const deleteFile = async (publicId, resourceType = 'image') => {
  try {
    // Use appropriate endpoint based on resource type
    const endpoint = resourceType === 'raw' 
      ? `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/raw/destroy`
      : `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/destroy`;
    
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        public_id: publicId,
        api_key: process.env.REACT_APP_CLOUDINARY_API_KEY,
        api_secret: process.env.REACT_APP_CLOUDINARY_API_SECRET,
        timestamp: Math.floor(Date.now() / 1000)
      })
    });

    const data = await response.json();
    return data.result === 'ok';
  } catch (error) {
    console.error('Cloudinary delete error:', error);
    throw error;
  }
};

export default cloudinary;
